export const SET_PERMISSIONS = "SET_PERMISSIONS";
export const CLEAR_PERMISSIONS = "CLEAR_PERMISSIONS";
